<template>
  <div class="trier">
    <label for="sort" class="sr-only">Trier par</label>
    <select
      id="sort"
      :value="modelValue"
      @change="onChange($event)"
      class="btn-select"
    >
      <option v-for="(label, value) in options" :key="value" :value="value">
        {{ label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Object, required: true },
    modelValue: { type: String, default: "" }
  },
  emits: ["update:modelValue", "change"],
  methods: {
    onChange(event) {
      const value = event.target.value
      this.$emit("update:modelValue", value)
      this.$emit("change", value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";

.trier {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-family: $campaign;
    font-size: 15px;
    font-weight: $regular;

    select {
        margin-left: 10px;
        max-width: 140px;
        font-family: $campaign;
        font-size: 15px;
        font-weight: $regular;

        @include min($lg) {
            margin-left: 20px;
        }
    }
}
</style>